import $ from 'jquery';

function sidebarToggle() {
	var $sidebar = $('.c-blog-sidebar'),
			$toggle  = $sidebar.find('.c-blog-sidebar_toggle');

	$toggle.click(function() {
		console.log('toggle clicked');
		if( $toggle.attr('aria-expanded') === 'true' ) {
			$toggle.attr({
				'aria-expanded': false,
				'aria-pressed': false
			});
			
			$sidebar.removeClass('is-expanded');
		}
		else {
			$toggle.attr({
				'aria-expanded': true,
				'aria-pressed': true
			});
			
			$sidebar.addClass('is-expanded');			
		}
	});
}

export { sidebarToggle };